<div class="error-wrapper contents animated fadeIn">
    <div class="error-contents">
        <img loading="lazy" src="assets/error.png">
        <div class="message">
            <h6>{{message}}</h6>
        </div>
        <button class="btn btn-secondary mt-3" (click)="coreService.goHome()">Return Home</button>
    </div>
</div>